module Meevo.Components.Controls.SmartMover {

    export class VariantModel extends SmartMoverModel<Model.Variant> implements ISmartMoverModel<Model.Variant> {

        get displayName() : string
        {
            let variantDisplayName = this.get("variantDisplayName") ? ` - ${this.get("variantDisplayName")}` : "" ;
            return `${this.get("sku")} : ${this.get("displayName")}${variantDisplayName}`;
        }
    }
}